import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MenuItem } from './menuItem';

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.css']
})
export class ContextMenuComponent implements OnInit {

  constructor() { }

  @Input() x = 0;
  @Input() y = 0;
  @Input() menuItems: MenuItem[];
  @Output() menuEvent = new EventEmitter<Function>();

  ngOnInit() {
  }

  public menuItemClicked(func: Function) {
      this.menuEvent.emit(func);

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/context-menu/context-menu.component.ts